import { render, staticRenderFns } from "./MinimumRedemptionDetail.vue?vue&type=template&id=0e308e7d&scoped=true"
import script from "./MinimumRedemptionDetail.vue?vue&type=script&lang=ts"
export * from "./MinimumRedemptionDetail.vue?vue&type=script&lang=ts"
import style0 from "./MinimumRedemptionDetail.vue?vue&type=style&index=0&id=0e308e7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e308e7d",
  null
  
)

export default component.exports